import request from '@/utils/request'

/**
 * 获取充放电记录列表
 * @param {Object} params
 * @param {String} params.startTime 开始时间
 * @param {String} params.endTime 结束时间
 * @param {Number|String} params.stationId 电站ID
 * @param {String} params.uuids 能量块UUID列表，逗号分隔
 * @param {Number} params.pageNum 页码
 * @param {Number} params.pageSize 每页显示数
 * @returns
 */
export function getChargeList({ startTime, endTime, stationId, uuids, pageNum = 1, pageSize = 20 }) {
  return request({
    url: '/dashboard/dataAnalysis/queryChargeAndDischargeRecord',
    method: 'get',
    params: {
      startTime,
      endTime,
      stationId: Number(stationId),
      uuids,
      pageNum,
      pageSize
    }
  })
}

/**
 * 导出充放电记录
 * @param {Object} params
 * @param {String} params.startTime 开始时间
 * @param {String} params.endTime 结束时间
 * @param {Number|String} params.stationId 电站ID
 * @param {String} params.uuids 能量块UUID列表，逗号分隔
 * @returns
 */
export function exportChargeAndDischargeRecord(params) {
  return request({
    url: '/dashboard/dataAnalysis/exportChargeAndDischargeRecord',
    method: 'get',
    params: {
      stationId: Number(params.stationId),
      uuids: params.uuids,
      startTime: params.startTime,
      endTime: params.endTime
    },
    responseType: 'blob'
  }).then(blob => {
    // 创建下载链接
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19)
    link.setAttribute('download', `充放记录_${timestamp}.xlsx`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  })
}

/**
 * 充放电记录和策略复合接口
 * @param {object} params 
 * @param {string} params.stationId 电站
 * @param {string} params.date 时间
 * @param {string} params.eLinkUuid 为空时查询所有eLink
 * @param {string} params.eBlockUuid 为空时查询所有eBlock
 * @returns 
 */
export function getStationRunningRecord(params) {
  return request({
    url: '/dashboard/v3/station/running/record',
    method: 'get',
    params: params
  })
}

